import { styled } from "styled-components";

export const TournamentTicketStoreWrapper = styled.div`
  width: calc(100% - 60px);
  height: calc(100% - 88px);

  padding: 44px 30px;

  display: flex;
  flex-direction: column;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const LogButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
  height: 42px;
  padding: 0 20px;
  box-sizing: border-box;
  border-radius: 21px;
  background: #121212;
  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;

export const HeaderWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 20px; 
  width: calc(100% - 48px);
  height: 62px;
  padding: 0 24px;

  border-radius: 10.64px;
  background: #ecf0f3;

  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 30px;

  > .box {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 12px;

    > .label {
      color: #333;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 120% */
    }

    > .seed {
      color: #7f25fb;
      font-family: Pretendard;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 21.5px; /* 119.444% */
    }

    > .value {
      color: #333;
      font-family: Pretendard;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 21.5px; /* 119.444% */
    }
  }
`;
